import { Comms } from '@leverege/comms'

import Api from './Api.js'

function init( options ) {
  if ( options.host == null ) {
    throw new Error( 'Api needs a host' )
  }
  
  return new Api( options )
}

export default {
  init
}

export {
  Api,
  Comms
}
